// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@200;300;400;600;700&amp;display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "DM Sans", sans-serif;
  src: url("https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap") format("woff2"), url("https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap") format("woff");
}
@font-face {
  font-family: "Inter", sans-serif;
  src: url("https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@200;300;400;600;700&amp;display=swap") format("woff2"), url("https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@200;300;400;600;700&amp;display=swap") format("woff");
}
@font-face {
  font-family: "Source Sans Pro", sans-serif;
  src: url("https://fonts.googleapis.com/css2?family=Source+Code+Pro:ital,wght@0,200..900;1,200..900&family=Source+Sans+3:ital,wght@0,200..900;1,200..900&display=swap") format("woff2"), url("https://fonts.googleapis.com/css2?family=Source+Code+Pro:ital,wght@0,200..900;1,200..900&family=Source+Sans+3:ital,wght@0,200..900;1,200..900&display=swap") format("woff");
}
body {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  background: #ffffff;
}

.login_login-bg__azF8j {
  background-color: #f2f3f6;
  box-shadow: 0 3px 5px 0 hsla(0, 0%, 84.7%, 0.75);
  border: 1px solid #ced4da;
}

.login_login-help__ox8iL {
  font-size: 40px;
  color: #939393;
  text-align: center;
  font-weight: 300;
  margin-top: 50px;
}

.login_user-register__T4Riq {
  padding: 0 !important;
  margin: 20px 40px !important;
}

.login_contact-info__tIibc {
  padding: 0 !important;
}

.login_frm-chck-pd-lft__k-2cS {
  padding-left: 0 !important;
}

@media screen and (max-width: 767px) {
  .login_login-bg__azF8j {
    background-color: #ffffff;
    border: 0;
    box-shadow: none;
    padding: 20px !important;
  }
  .login_user-register__T4Riq {
    margin: 0 !important;
  }
  .login_login-help__ox8iL {
    text-align: left;
    margin-top: 20px;
  }
  .login_commercial-login__sjIuP.login_contact-info__tIibc {
    padding: 0 !important;
  }
}
@media screen and (min-width: 768px) and (max-width: 1024px) {
  .login_user-register__T4Riq {
    margin: 0 !important;
  }
}
.login_commercial-login__sjIuP {
  width: 100%;
  padding: 20px;
  margin: auto;
  margin-top: 5%;
  border-radius: 0px;
  min-height: auto;
}
@media screen and (max-width: 767px) {
  .login_commercial-login__sjIuP {
    width: 100%;
    padding: 20px !important;
    margin-top: 50px !important;
  }
  .login_commercial-login__sjIuP .login_d-mob-block__qa9E- {
    display: block;
  }
  .login_commercial-login__sjIuP h2 {
    text-align: left !important;
  }
  .login_commercial-login__sjIuP h4 {
    font-weight: 700 !important;
  }
  .login_commercial-login__sjIuP .login_login-form__7ZW05 .login_forgot-pwd__sQDvh {
    float: left !important;
  }
  .login_commercial-login__sjIuP .login_login-form__7ZW05 label {
    margin-top: 20px;
    margin-left: 10px;
  }
  .login_commercial-login__sjIuP .login_download-app__CSsg9 {
    flex-direction: column !important;
    align-items: center;
  }
  .login_commercial-login__sjIuP .login_download-app__CSsg9 a {
    margin-bottom: 20px !important;
  }
  .login_commercial-login__sjIuP .login_contact-information__lQ0RQ {
    margin-top: 0px !important;
  }
}
.login_commercial-login__sjIuP h2 {
  font-size: 40px;
  color: #9e9e9e;
  text-align: center;
  font-family: "Source Sans Pro", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  font-weight: 200;
  letter-spacing: normal;
  margin-top: 0px;
  margin-bottom: 16px;
}
.login_commercial-login__sjIuP h3 {
  font-size: 24px;
  color: #000000;
  text-align: center;
  font-family: "DM Sans", sans-serif;
  font-weight: 500;
  letter-spacing: normal;
  margin-top: 10px;
  color: #222222;
}
.login_commercial-login__sjIuP h4 {
  font-size: 24px;
  color: #73c573;
  text-align: left;
  font-family: "DM Sans", sans-serif;
  font-weight: 900;
  letter-spacing: normal;
  margin-top: 60px;
  margin-bottom: 0;
}
.login_commercial-login__sjIuP p {
  font-family: Inter;
  font-weight: 300;
  font-size: 20px;
  line-height: 150%;
  letter-spacing: normal;
  color: #414141;
  margin-bottom: 60px;
}
.login_commercial-login__sjIuP .login_login-head__eBLW8 h1 {
  font-size: 44px;
  font-weight: 300;
  color: #4f785f;
  margin-bottom: 24px;
  font-family: "Source Sans Pro", sans-serif;
}
.login_commercial-login__sjIuP .login_login-head__eBLW8 span {
  font-size: 20px;
  font-weight: 300;
  color: #666666 !important;
  margin-bottom: 24px;
  font-family: "Source Sans Pro", sans-serif;
}
.login_commercial-login__sjIuP .login_login-form__7ZW05 {
  margin-top: 20px;
}
@media (max-width: 767px) {
  .login_commercial-login__sjIuP .login_login-form__7ZW05 {
    margin-top: 0;
  }
}
.login_commercial-login__sjIuP .login_login-form__7ZW05 label {
  display: block;
  font-size: 20px;
  color: #1c1c1c;
  margin-bottom: 5px;
  font-family: "Source Sans Pro", sans-serif;
  font-weight: 300;
  line-height: 110%;
  margin-left: 0;
}
@media screen and (max-width: 767px) {
  .login_commercial-login__sjIuP .login_login-form__7ZW05 label {
    margin: 0;
  }
}
.login_commercial-login__sjIuP .login_login-form__7ZW05 input[type=text],
.login_commercial-login__sjIuP .login_login-form__7ZW05 input[type=password] {
  width: 100%;
  padding: 8px 18px;
  margin-bottom: 15px;
  border: 1px solid #ced4da;
  font-size: 16px;
  font-family: "Source Sans Pro", sans-serif;
  border-radius: unset;
  color: #222222;
}
.login_commercial-login__sjIuP .login_login-form__7ZW05 .login_btn-primary__Sp\\+yi.login_login-btn__QHj0D {
  font-family: "Source Sans Pro", sans-serif;
  font-weight: 400;
  font-size: 26px;
  line-height: 120%;
  letter-spacing: normal;
  text-align: center;
  text-transform: capitalize;
  background-color: #FFB034;
  color: #ffffff;
  min-width: 177px;
  height: 48px;
  border-radius: 0px;
  border: 0;
  width: 100%;
  margin-top: 20px;
}
.login_commercial-login__sjIuP .login_login-form__7ZW05 .login_btn-primary__Sp\\+yi.login_login-btn__QHj0D:hover {
  text-decoration: underline;
}
.login_commercial-login__sjIuP .login_login-form__7ZW05 .login_form-check-input__kxjWj:checked {
  background-color: #000000;
  border-color: #000000;
}
.login_commercial-login__sjIuP .login_login-form__7ZW05 .login_form-check-input__kxjWj:focus {
  box-shadow: none;
}
.login_commercial-login__sjIuP .login_login-form__7ZW05 .login_form-control__HPyMp:focus,
.login_commercial-login__sjIuP .login_login-form__7ZW05 .login_btn-primary__Sp\\+yi:focus {
  box-shadow: none;
}
.login_commercial-login__sjIuP .login_login-form__7ZW05 .login_form-check-input__kxjWj {
  margin-top: 0;
  width: 20px;
  height: 20px;
  border-radius: 0;
  border: 1px solid #666666;
}
.login_commercial-login__sjIuP .login_login-form__7ZW05 .login_forgot-pwd__sQDvh {
  float: right;
  font-size: 20px;
  color: #FFB034;
  text-decoration: underline;
  font-family: "Source Sans Pro", sans-serif;
  font-weight: 300;
  margin-top: -2px;
}
.login_commercial-login__sjIuP .login_login-form__7ZW05 .login_forgot-pwd__sQDvh:hover {
  text-decoration: none;
}
.login_commercial-login__sjIuP .login_login-form__7ZW05 .login_forgot-pwd-div__Jmd6V {
  display: flex;
  justify-content: space-between;
}
@media screen and (max-width: 767px) {
  .login_commercial-login__sjIuP .login_login-form__7ZW05 .login_forgot-pwd-div__Jmd6V {
    padding-left: 0;
  }
}
.login_commercial-login__sjIuP .login_btn-links__av6fQ {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}
.login_commercial-login__sjIuP .login_btn-links__av6fQ img {
  width: 180px;
}
.login_commercial-login__sjIuP .login_register__L8EX9 {
  font-size: 26px;
  color: #ffffff;
  text-decoration: none;
  font-family: "Source Sans Pro", sans-serif;
  font-weight: 400;
  width: 100%;
  height: 48px;
  background: #9e9e9e;
  border-radius: 0px;
  padding: 7px 10px;
  text-align: center;
  line-height: 1.2;
}
.login_commercial-login__sjIuP .login_register__L8EX9:hover {
  text-decoration: underline;
  background: #858585;
}
.login_commercial-login__sjIuP a.login_pay-bill__8u2lQ {
  font-size: 26px;
  color: #ffffff;
  text-decoration: none;
  font-family: "Source Sans Pro", sans-serif;
  font-weight: 400;
  width: 100%;
  height: 48px;
  background: #9e9e9e;
  border-radius: 0px;
  padding: 7px 10px;
  text-align: center;
  line-height: 1.2;
}
.login_commercial-login__sjIuP a.login_pay-bill__8u2lQ:hover {
  text-decoration: underline;
  background: #858585;
}
.login_commercial-login__sjIuP .login_contact-information__lQ0RQ {
  margin-top: 30px;
  text-decoration: none;
  color: #1c1c1c;
}
.login_commercial-login__sjIuP .login_contact-information__lQ0RQ:hover {
  text-decoration: underline;
}
.login_commercial-login__sjIuP .login_contact-information__lQ0RQ p {
  font-family: "Source Sans Pro", sans-serif;
  font-weight: 300;
  color: #1c1c1c;
  font-size: 26px;
  line-height: 1.2;
  letter-spacing: normal;
  margin-bottom: 0px;
}
.login_commercial-login__sjIuP .login_contact-information__lQ0RQ .login_cust-support__hA3OQ {
  color: #FFB034;
  font-weight: 300;
  text-decoration: underline;
}
.login_commercial-login__sjIuP .login_contact-information__lQ0RQ .login_cust-support__hA3OQ:hover {
  text-decoration: none;
}
.login_commercial-login__sjIuP .login_mr-20__3HMtb {
  margin-right: 20px;
}

.login_errorMsg__AfZCa {
  color: #d1002f;
  display: block;
  font-size: 14px;
  margin-bottom: 5px;
  font-weight: 400;
}

.login_successMsg__pdzcu {
  color: #28a745;
  display: block;
  font-size: 14px;
  margin-bottom: 5px;
  font-weight: 400;
}

.login_errorInput__ou6lc {
  border-color: red !important;
}

.login_commercial-login__sjIuP .login_login-form__7ZW05 input[type=text],
.login_commercial-login__sjIuP .login_login-form__7ZW05 input[type=email],
.login_commercial-login__sjIuP .login_login-form__7ZW05 input[type=password] {
  width: 100%;
  padding: 8px 18px;
  margin-bottom: 15px;
  border: 1px solid #ced4da;
  font-size: 16px;
  font-family: "Inter", sans-serif;
  border-radius: unset;
  color: #222222;
}
.login_commercial-login__sjIuP .login_login-form__7ZW05 input[type=text]:focus,
.login_commercial-login__sjIuP .login_login-form__7ZW05 input[type=email]:focus,
.login_commercial-login__sjIuP .login_login-form__7ZW05 input[type=password]:focus {
  border-color: #cdeacd !important;
  box-shadow: 0 0 0 0 rgba(115, 197, 115, 0.25) !important;
  outline: none;
}
.login_commercial-login__sjIuP .login_login-form__7ZW05 input[type=text]::placeholder,
.login_commercial-login__sjIuP .login_login-form__7ZW05 input[type=email]::placeholder,
.login_commercial-login__sjIuP .login_login-form__7ZW05 input[type=password]::placeholder {
  font-style: italic;
  font-weight: 300;
}`, "",{"version":3,"sources":["webpack://./src/styles/base/_fonts.scss","webpack://./src/styles/login.module.scss","webpack://./src/styles/abstracts/_variables.scss"],"names":[],"mappings":"AAOA;EACE,kCAAA;EACA,oRAAA;ACHF;ADQA;EACE,gCAAA;EACA,wPAAA;ACNF;ADUA;EACE,0CAAA;EACA,wWAAA;ACRF;AAZA;EACI,SAAA;EACA,UAAA;EACA,sBAAA;EACA,mBC2CI;AD7BR;;AAZA;EACI,yBCqFW;EDpFX,gDAAA;EACA,yBAAA;AAeJ;;AAZA;EACI,eAAA;EACA,cCiDK;EDhDL,kBAAA;EACA,gBAAA;EACA,gBAAA;AAeJ;;AAbA;EACI,qBAAA;EACA,4BAAA;AAgBJ;;AAdA;EACI,qBAAA;AAiBJ;;AAfA;EACQ,0BAAA;AAkBR;;AAhBA;EACI;IACI,yBCgBA;IDfA,SAAA;IACA,gBAAA;IACA,wBAAA;EAmBN;EAjBE;IACI,oBAAA;EAmBN;EAjBE;IACI,gBAAA;IACA,gBAAA;EAmBN;EAjBE;IACI,qBAAA;EAmBN;AACF;AAhBA;EACI;IACI,oBAAA;EAkBN;AACF;AAhBA;EACI,WAAA;EACA,aCkEO;EDjEP,YAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AAkBJ;AAfI;EATJ;IAWQ,WAAA;IACA,wBAAA;IACA,2BAAA;EAiBN;EAhBM;IACI,cAAA;EAkBV;EAhBM;IACI,2BAAA;EAkBV;EAhBM;IACI,2BAAA;EAkBV;EAhBM;IACI,sBAAA;EAkBV;EAhBM;IACI,gBAAA;IACA,iBAAA;EAkBV;EAfM;IACI,iCAAA;IACA,mBAAA;EAiBV;EAfM;IACI,8BAAA;EAiBV;EAfM;IACI,0BAAA;EAiBV;AACF;AAdI;EACI,eAAA;EACA,cCjCC;EDkCD,kBAAA;EACA,oLAAA;EACA,gBAAA;EACA,sBAAA;EACA,eAAA;EACA,mBAAA;AAgBR;AAbI;EACI,eAAA;EACA,cC/DA;EDgEA,kBAAA;EACA,kCC4BE;ED3BF,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,cCnED;ADkFP;AAZI;EACI,eAAA;EACA,cC3CA;ED4CA,gBAAA;EACA,kCCiBE;EDhBF,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;AAcR;AAZI;EACI,kBCWK;EDVL,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,cC1EM;ED2EN,mBAAA;AAcR;AAVS;EACG,eAAA;EACA,gBCVP;EDWO,cC7DI;ED8DJ,mBAAA;EACA,0CCDQ;ADapB;AAVQ;EACI,eAAA;EACA,gBCjBP;EDkBO,yBAAA;EACA,mBAAA;EACA,0CCRQ;ADoBpB;AARI;EACI,gBAAA;AAUR;AATQ;EAFJ;IAGQ,aAAA;EAYV;AACF;AAXQ;EACI,cAAA;EACA,eAAA;EACA,cCnGH;EDoGG,kBAAA;EACA,0CCtBQ;EDuBR,gBAAA;EACA,iBAAA;EACA,cAAA;AAaZ;AAZa;EATL;IAUQ,SAAA;EAed;AACF;AAZQ;;EAEI,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,0CCtCQ;EDuCR,oBAAA;EACA,cCvIL;ADqJP;AAXQ;EACI,0CC5CQ;ED6CR,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,0BAAA;EACA,yBC9GJ;ED+GI,cCpJJ;EDqJI,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;AAaZ;AAVQ;EACI,0BAAA;AAYZ;AATQ;EACI,yBCnKJ;EDoKI,qBCpKJ;AD+KR;AARQ;EACI,gBAAA;AAUZ;AAPQ;;EAEI,gBAAA;AASZ;AANQ;EACI,aAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,yBAAA;AAQZ;AALQ;EACI,YAAA;EACA,eAAA;EACA,cCrJJ;EDsJI,0BAAA;EACA,0CC5FQ;ED6FR,gBAAA;EACA,gBAAA;AAOZ;AANY;EACI,qBAAA;AAQhB;AAJQ;EACI,aAAA;EACA,8BAAA;AAMZ;AALY;EAHJ;IAIQ,eAAA;EAQd;AACF;AAJI;EACI,aAAA;EACA,8BAAA;EACA,gBAAA;AAMR;AAJQ;EACI,YAAA;AAMZ;AAFI;EACI,eAAA;EACA,cCzNA;ED0NA,qBAAA;EACA,0CC3HY;ED4HZ,gBAAA;EACA,WAAA;EACA,YAAA;EACA,mBC7MC;ED8MD,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;AAIR;AAFQ;EACI,0BAAA;EACA,mBCpNH;ADwNT;AAAI;EACI,eAAA;EACA,cC7OA;ED8OA,qBAAA;EACA,0CC/IY;EDgJZ,gBAAA;EACA,WAAA;EACA,YAAA;EACA,mBCjOC;EDkOD,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;AAER;AAAQ;EACI,0BAAA;EACA,mBCxOH;AD0OT;AAEI;EACI,gBAAA;EACA,qBAAA;EACA,cCjPC;ADiPT;AAEQ;EACI,0BAAA;AAAZ;AAGQ;EACI,0CCzKQ;ED0KR,gBAAA;EACA,cC1PH;ED2PG,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;AADZ;AAGQ;EACI,cC7OJ;ED8OI,gBAAA;EACA,0BAAA;AADZ;AAEY;EACI,qBAAA;AAAhB;AAKK;EACO,kBAAA;AAHZ;;AAOA;EACI,cAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AAJJ;;AAOA;EACI,cAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AAJJ;;AAOA;EACI,4BAAA;AAJJ;;AAMA;;;EAGI,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,gCAAA;EACA,oBAAA;EACA,cAAA;AAHJ;AAKI;;;EACI,gCAAA;EACA,wDAAA;EACA,aAAA;AADR;AAII;;;EACI,kBAAA;EACA,gBAAA;AAAR","sourcesContent":["// -----------------------------------------------------------------------------\n// This file contains all @font-face declarations, if any.\n// -----------------------------------------------------------------------------\n@import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@200;300;400;600;700&amp;display=swap');\n\n@font-face {\n  font-family: \"DM Sans\", sans-serif;\n  src: url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap') format('woff2'),\n  url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap') format('woff');\n  \n}\n\n@font-face {\n  font-family: \"Inter\", sans-serif;\n  src: url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@200;300;400;600;700&amp;display=swap') format('woff2'),\n       url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@200;300;400;600;700&amp;display=swap') format('woff');\n}\n\n@font-face {\n  font-family: \"Source Sans Pro\", sans-serif;\n  src: url('https://fonts.googleapis.com/css2?family=Source+Code+Pro:ital,wght@0,200..900;1,200..900&family=Source+Sans+3:ital,wght@0,200..900;1,200..900&display=swap') format('woff2'),\n       url('https://fonts.googleapis.com/css2?family=Source+Code+Pro:ital,wght@0,200..900;1,200..900&family=Source+Sans+3:ital,wght@0,200..900;1,200..900&display=swap') format('woff');\n}","@use 'abstracts/variables' as *;\n\nbody {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n    background: $white;\n}\n.login-bg{\n    background-color: $bg-grey-login;\n    box-shadow: 0 3px 5px 0 hsla(0, 0%, 84.7%, .75);\n    border: 1px solid #ced4da;\n        \n}\n.login-help{\n    font-size: 40px;\n    color: $grey3;\n    text-align: center;\n    font-weight: 300;\n    margin-top: 50px;\n}\n.user-register{\n    padding: 0 !important;\n    margin: 20px 40px !important;\n}\n.contact-info{\n    padding: 0 !important;\n}\n.frm-chck-pd-lft{\n        padding-left: 0 !important;\n}\n@media screen and (max-width:767px) {\n    .login-bg{\n        background-color: $white;\n        border: 0;\n        box-shadow: none;\n        padding: $padding20 !important;\n    }\n    .user-register{\n        margin: 0 !important;\n    }\n    .login-help{\n        text-align: left;\n        margin-top: 20px;\n    }\n    .commercial-login.contact-info {\n        padding: 0 !important;\n    }\n\n}\n@media screen and (min-width:768px) and (max-width:1024px){\n    .user-register{\n        margin: 0 !important;\n    }\n}\n.commercial-login {\n    width: 100%;\n    padding: $padding20;\n    margin: auto;\n    margin-top: 5%;\n    border-radius: 0px;\n    min-height: auto;\n\n    \n    @media screen and (max-width:767px) {\n     \n        width: 100%;\n        padding: $padding20 !important;\n        margin-top: 50px !important;\n        .d-mob-block{\n            display: block;;\n        }\n        h2{\n            text-align: left !important;\n        }\n        h4{\n            font-weight: 700 !important;\n        }\n        .login-form .forgot-pwd{\n            float: left !important;\n        }\n        .login-form label{\n            margin-top: 20px;\n            margin-left: 10px;\n        }\n     \n        .download-app{\n            flex-direction: column !important;    \n            align-items: center;        \n        }\n        .download-app a{\n            margin-bottom: 20px !important;\n        }\n        .contact-information {\n            margin-top: 0px !important;\n        }\n    }\n\n    h2 {\n        font-size: 40px;\n        color: $grey5;\n        text-align: center;\n        font-family: \"Source Sans Pro\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n        font-weight: 200;\n        letter-spacing: normal;\n        margin-top: 0px;\n        margin-bottom: 16px;\n    }\n\n    h3 {\n        font-size: 24px;\n        color: $black;\n        text-align: center;\n        font-family: $font-dm;\n        font-weight: 500;\n        letter-spacing: normal;\n        margin-top: 10px;\n        color: $gray;\n    }\n\n    h4 {\n        font-size: 24px;\n        color: $green4;\n        text-align: left;\n        font-family: $font-dm;\n        font-weight: 900;\n        letter-spacing: normal;\n        margin-top: 60px;\n        margin-bottom: 0;\n    }\n    p {\n        font-family: $font-inter;\n        font-weight: 300;\n        font-size: 20px;\n        line-height: 150%;\n        letter-spacing: normal;\n        color: $light-gray;\n        margin-bottom: 60px;\n    }\n\n    .login-head{\n         h1{\n            font-size: 44px;\n            font-weight: $fw3;\n            color: $light-green1 ;\n            margin-bottom: 24px;\n            font-family: $source-sans-pro;\n        }\n        span{\n            font-size: 20px;\n            font-weight: $fw3;\n            color: $light-gray2 !important;\n            margin-bottom: 24px;\n            font-family: $source-sans-pro;\n        }\n    }\n\n    .login-form {\n        margin-top: 20px;\n        @media (max-width: 767px) {\n            margin-top: 0;\n        }\n        label {\n            display: block;\n            font-size: 20px;\n            color: $grey4;\n            margin-bottom: 5px;\n            font-family: $source-sans-pro;\n            font-weight: 300;\n            line-height: 110%;\n            margin-left: 0;\n             @media screen and (max-width:767px) {\n                margin: 0;\n             }\n        }\n\n        input[type=text],\n        input[type=password] {\n            width: 100%;\n            padding: 8px 18px;\n            margin-bottom: 15px;\n            border: 1px solid $border-grey;\n            font-size: 16px;\n            font-family:  $source-sans-pro;\n            border-radius: unset;\n            color: $gray;\n        }\n\n        .btn-primary.login-btn {\n            font-family:  $source-sans-pro;\n            font-weight: 400;\n            font-size: 26px;\n            line-height: 120%;\n            letter-spacing: normal;\n            text-align: center;\n            text-transform: capitalize;\n            background-color: $yellow;\n            color: $white;\n            min-width: 177px;\n            height: 48px;\n            border-radius: 0px;\n            border:0;\n            width: 100%;\n            margin-top: 20px;\n\n        }\n        .btn-primary.login-btn:hover {\n            text-decoration: underline;\n        }\n\n        .form-check-input:checked {\n            background-color: $black;\n            border-color: $black;\n        }\n\n        .form-check-input:focus {\n            box-shadow: none;\n        }\n\n        .form-control:focus,\n        .btn-primary:focus {\n            box-shadow: none;\n        }\n\n        .form-check-input {\n            margin-top: 0;\n            width: 20px;\n            height: 20px;\n            border-radius: 0;\n            border:1px solid $light-gray2;\n        }\n\n        .forgot-pwd {\n            float: right;\n            font-size: 20px;\n            color: $yellow;\n            text-decoration: underline;\n            font-family:  $source-sans-pro;\n            font-weight: 300;\n            margin-top: -2px;\n            &:hover{\n                text-decoration: none;\n            }\n        }\n\n        .forgot-pwd-div {\n            display: flex;\n            justify-content: space-between;\n            @media screen and (max-width:767px) {\n                padding-left: 0;\n            }\n        }\n    }\n\n    .btn-links {\n        display: flex;\n        justify-content: space-between;\n        margin-top: 20px;\n\n        img {\n            width: 180px;\n        }\n    }\n\n    .register {\n        font-size: 26px;\n        color: $white;\n        text-decoration: none;\n        font-family:  $source-sans-pro;\n        font-weight: 400;\n        width: 100%;\n        height: 48px;\n        background: $grey5;\n        border-radius: 0px;\n        padding: 7px 10px;\n        text-align: center;\n        line-height: 1.2;\n\n        &:hover {\n            text-decoration: underline;\n            background: $grey6;\n        }\n    }\n\n    a.pay-bill {\n        font-size: 26px;\n        color: $white;\n        text-decoration: none;\n        font-family:  $source-sans-pro;\n        font-weight: 400;\n        width: 100%;\n        height: 48px;\n        background: $grey5;\n        border-radius: 0px;\n        padding: 7px 10px;\n        text-align: center;\n        line-height: 1.2;\n\n        &:hover {\n            text-decoration: underline;\n            background: $grey6;\n        }\n    }\n\n    .contact-information {\n        margin-top: 30px;\n        text-decoration: none;\n        color: $grey4;\n\n        &:hover {\n            text-decoration: underline;\n        }\n        \n        p {\n            font-family:  $source-sans-pro;\n            font-weight: 300;\n            color: $grey4;\n            font-size: 26px;\n            line-height: 1.2;\n            letter-spacing: normal;\n            margin-bottom: 0px;\n        }\n        .cust-support{\n            color: $yellow;\n            font-weight: 300;\n            text-decoration: underline;\n            &:hover{\n                text-decoration: none;\n            }\n        }\n       \n    }\n     .mr-20{\n            margin-right: 20px;\n        }\n}\n\n.errorMsg {\n    color: #d1002f;\n    display: block;\n    font-size: 14px;\n    margin-bottom: 5px;\n    font-weight: 400;\n}\n\n.successMsg {\n    color: #28a745;\n    display: block;\n    font-size: 14px;\n    margin-bottom: 5px;\n    font-weight: 400;\n}\n\n.errorInput{\n    border-color: red !important;\n}\n.commercial-login .login-form input[type=text],\n.commercial-login .login-form input[type=email],\n.commercial-login .login-form input[type=password] {\n    width: 100%;\n    padding: 8px 18px;\n    margin-bottom: 15px;\n    border: 1px solid #ced4da;\n    font-size: 16px;\n    font-family: \"Inter\", sans-serif;\n    border-radius: unset;\n    color: #222222;\n\n    &:focus {\n        border-color: #cdeacd!important;\n        box-shadow: 0 0 0 0 rgba(115,197,115,.25)!important;\n        outline: none;\n    }\n\n    &::placeholder {\n        font-style: italic;\n        font-weight: 300;\n    }\n}\n\n","// -----------------------------------------------------------------------------\n// This file contains all application-wide Sass variables.\n// -----------------------------------------------------------------------------\n\n\n//Fonts \n\n\n@import \"../base/fonts\";\n\n\n$roboto-regular : 'Roboto-regular';\n$roboto-bold: 'Roboto-bold';\n$roboto-medium: 'Roboto-medium';\n$roboto-light-italic: 'Roboto-light-italic';\n\n/// Regular font family\n/// @type List\n//$text-font-stack: 'Open Sans', 'Helvetica Neue Light', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif !default;\n\n/// Code (monospace) font family\n/// @type List\n//$code-font-stack: 'Courier New', 'DejaVu Sans Mono', 'Bitstream Vera Sans Mono', 'Monaco', monospace !default;\n\n\n\n\n\n/// Copy text color\n/// @type Color\n$text-color: rgb(34, 34, 34) !default;\n\n/// Main brand color\n/// @type Color\n$brand-color: rgb(229, 0, 80) !default;\n\n/// Light grey\n/// @type Color\n$light-grey: rgb(237, 237, 237) !default;\n\n/// Medium grey\n/// @type Color\n$mid-grey: rgb(153, 153, 153) !default;\n\n/// Dark grey\n/// @type Color\n$dark-grey: rgb(68, 68, 68) !default;\n\n$black: #000000;\n$white: #ffffff;\n$gray: #222222;\n$grey3 : #939393;\n$grey4 : #1c1c1c;\n$grey5 : #9e9e9e;\n$grey6 : #858585;\n\n$hover-grey: #b8babf;\n$gray7:#333333;\n$gray8:#CCCCCC;\n$gray9:#dddddd;\n$gray10:#57606a;\n$gray11:#999999;\n$light-gray : #414141;\n$light-gray2 : #666666;\n$gray2 : #4F4F4F;\n$grey3 : #939393;\n$grey4 : #1c1c1c;\n$grey5 : #9e9e9e;\n$grey6 : #858585;\n$grey7 : #d9d9d9;\n$grey8 : #e6e9ee;\n$grey9 : #e6e6e9;\n$hover-grey: #b8babf;\n$stone : #CACACA;\n$gray-bg :#EBF9F0;\n$green:#046A38;\n$green2:#1EE576;\n$green3:#19C063;\n$green5:#2a8056;\n$green4:#73c573;\n$green7:#70c66f;\n$dark-green:#00873C;\n$light-green:#00B140;\n$light-green1 : #4f785f;\n$red : #FF0000;\n$light-red:#ff3c3c;\n$yellow:#FFB034;\n$dark-yellow:#e2a014;\n$yellow-hover:#cd7d00;\n$blue :#0A1AB4;\n$orange:#EA6B1F;\n$purple:#6A1B85;\n$offwhite:#F5F7F5;\n$offwhite1:#E0E0E0;\n$bg-grey-login:#f2f3f6;\n$border-grey: #ced4da;\n$bl-grey: #6c757d;\n$bl-green:#00703c;\n$bl-darkgrey: #b0b0b0;\n$bg-white1:#F5F5F5;\n$bg-white2:#FAFAFA;\n$red1: #d1002f;\n\n$yellow-hover:#cd7d00;\n\n\n$font-dm: \"DM Sans\", sans-serif;\n$font-inter: Inter;\n$font-inter-ss: \"Inter\", sans-serif;\n\n$margin0:0px;\n$margin10:10px;\n$margin15:15px; \n$margin20:20px;\n$margin30:30px; \n$margin40:40px;\n$margin50:50px;\n$margin60:60px;\n\n$padding0:0px;\n$padding10:10px;\n$padding15:15px;    \n$padding16:16px;    \n$padding20:20px;\n$padding30:30px;  \n$padding40:40px;\n$padding50:50px;\n\n$br-0:0px;\n\n$br-0:0px;\n$fw1:100;\n$fw2:200;\n$fw3:300;\n$fw4:400;\n$fw5:500;\n$fw6:600;\n$fw7:700;\n$fw8:800;\n$fw9:900;\n\n$font-dm: \"DM Sans\", sans-serif;\n$font-inter: Inter;\n$font-inter-ss: \"Inter\", sans-serif;\n\n$source-sans-pro:   \"Source Sans Pro\" , sans-serif ;\n\n/// Container's maximum width\n/// @type Length\n$max-width: 1180px !default;\n\n\n\n\n\n/// Breakpoints map\n/// @prop {String} keys - Keys are identifiers mapped to a given length\n/// @prop {Map} values - Values are actual breakpoints expressed in pixels\n$breakpoints: (\n  'small': 320px,\n  'medium': 768px,\n  'large': 1024px,\n) !default;\n\n\n\n\n\n\n/// Relative or absolute URL where all assets are served from\n/// @type String\n/// @example scss - When using a CDN\n///   $base-url: 'https://cdn.example.com/assets/';\n$base-url: '/assets/' !default;\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"login-bg": `login_login-bg__azF8j`,
	"login-help": `login_login-help__ox8iL`,
	"user-register": `login_user-register__T4Riq`,
	"contact-info": `login_contact-info__tIibc`,
	"frm-chck-pd-lft": `login_frm-chck-pd-lft__k-2cS`,
	"commercial-login": `login_commercial-login__sjIuP`,
	"d-mob-block": `login_d-mob-block__qa9E-`,
	"login-form": `login_login-form__7ZW05`,
	"forgot-pwd": `login_forgot-pwd__sQDvh`,
	"download-app": `login_download-app__CSsg9`,
	"contact-information": `login_contact-information__lQ0RQ`,
	"login-head": `login_login-head__eBLW8`,
	"btn-primary": `login_btn-primary__Sp+yi`,
	"login-btn": `login_login-btn__QHj0D`,
	"form-check-input": `login_form-check-input__kxjWj`,
	"form-control": `login_form-control__HPyMp`,
	"forgot-pwd-div": `login_forgot-pwd-div__Jmd6V`,
	"btn-links": `login_btn-links__av6fQ`,
	"register": `login_register__L8EX9`,
	"pay-bill": `login_pay-bill__8u2lQ`,
	"cust-support": `login_cust-support__hA3OQ`,
	"mr-20": `login_mr-20__3HMtb`,
	"errorMsg": `login_errorMsg__AfZCa`,
	"successMsg": `login_successMsg__pdzcu`,
	"errorInput": `login_errorInput__ou6lc`
};
export default ___CSS_LOADER_EXPORT___;
